// Importing React to build the component.
import React, { useState } from 'react';

// Importing the Bootstrap Form and Button components.
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

// Importing the CSS file for styling the feedback form.
import '../FeedbackPage.css';

import APIService from '../APIService';

// FeedbackForm component: Contains a form for users to submit their feedback.
function FeedbackForm() {
    const [feedback, setFeedback] = useState('');
    const [showModal, setShowModal] = useState(false);

    // Handle feedback input change
    const handleInputChange = (event) => {
        setFeedback(event.target.value);
    };

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();
        // Here you can handle feedback submission logic (e.g., sending it to a server)
        APIService.InsertFeedback(feedback);
        setFeedback('');
        setShowModal(true);
    };

    const handleClose = () => setShowModal(false);

    return (
        <div className="form-container">
        <Form onSubmit={handleSubmit}>
            <Form.Group controlId="feedbackText" className="form-group">
                <Form.Label className="feedbackLabel">
                    Don't know what to share? Here's some things we would love to hear your feedback on: <br></br>
                    AI Tutor response time, AI Tutor responses, Profile Page settings, usefulness of the Help Page, Academic Integrity constraints, and anything else about the Miami AI Tutor Website!
                </Form.Label>
                <Form.Control
                    as="textarea"
                    rows={4}
                    value={feedback}
                    onChange={handleInputChange}
                    placeholder="Write your feedback here..."
                    className="form-control"
                />
            </Form.Group>
            <Button className="feedbackSubmit" type="submit">
                Submit Feedback
            </Button>
        </Form>
        <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Thank you for your feedback!</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
            <Button className="modalButton" variant="secondary" onClick={handleClose}>
                Close
            </Button>
        </Modal.Footer>
    </Modal>
    </div>
    );
}

// Exporting the FeedbackForm component so it can be imported and used in other parts of the app.
export default FeedbackForm;
